import {
  SubscriptionDetailsItemViewModel,
  SubscriptionDetailsViewModel,
  CspAzureLocationModel,
} from './../models/subscription-details-view.model';
import {
  CSPModifySubscriptionViewModel,
  CSPModifySubscriptionResponse,
  CSPItemListViewModel,
  CSPUsageDetailsViewModel,
  CSPPerpetualItemViewModel,
  CSPPerpetualItemsViewModel,
  CSPPerpetualModifyViewModel,
  CSPPerpetual_AzureRISubscriptionViewModel,
  CSPPerpetualEntitlementsViewModel,
  CSPPerpetualDownloadOptionsViewModel,
  CspAzureRicatalog,
  CspAzureRilist,
  GetProductPricingV2,
  ManagementLink,
  KASPChildSKUModel,
  CSPSubscriptions, GetCSPTenant,
  CSPTenantUser,
  GetCSPSubscription,
  ProductTerm,
  MCEUpgradeModel,
  CSPMigrationToNCE,
  AdminRelationship,
  SupportedBillingCycle,
  WGSubscriptionModel,
  WGSubscriptionResponse,
  AssociateValidationResult,
  BulkOrderValidationResult,
  DickerSelectListItem,
  SubscriptionAction,
  ICSP_CustomerPricing,
  IAMPAssociationResponse
} from './../models/csp.model';
import {
  AnnuityViewModel,
  AnnuityItemsViewModel,
  AnnuityListViewModel,
  I_AnnuityItemsViewModel,
} from './../models/annuity-view.model';
import { catchError, first, map } from 'rxjs/operators';
import {
  ManageByProgram,
  ManageByPerpetual,
  SubscriptionPrograms,
} from './../models/imanage.model';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
// tslint:disable-next-line:import-blacklist
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import {
  ADKDetailsItemViewModel,
  ADKDetailsViewModel,
  PendingChangeModel,
} from '../models/adk-details-view.model';
import {
  SubscriptionApiResponse,
  PerpetualApiResponse,
  ApiResponse,
  MnpIdAipiResponse,
} from '../models/api-response.model';
import { CSPDetailsItemViewModel } from '../models/csp.model';
import {
  AnnuityDetailsViewModel,
  AnnuityItems,
} from '../models/annuity-details-view.model';
import {
  LTEDetailsViewModel,
  LTEDetailsItems,
  LTEPurchaseViewModel,
} from '../models/lte-details-view.model';
import { AuthService } from './auth.service';
import { PartnerProgramDetail } from '../models/partnerProgramDetail.model';
import { ADOpportunityByPartnerCSNAndDateRange } from '../models/ad-opportunity.model';
import {
  TransactOpportunityInput,
  TransactOpportunityModel,
} from '../models/transactOpportunity.model';
import { CirrusTenantResponse, CirrusCancelSubscriptionResponse, TenantResponse } from '../models/check-out.model';
import { Order } from '../models/orders.model';
// import CspItem for ReserverdInstance and Software
import { CSPCustomerEntitlementsViewModel } from '../models/csp.model';
import { PaymentDetails } from '../models/subscription-payment-detail.model';
import { QuoteOrderItem } from '../quotes/price-list/price-list-detail/price-list-summary/price-list-summary.component';
import { TransitionEligibility } from '../models/transitionEligibility.mode';
import { Transition } from '../models/transition.model';
import { Notifications, Request } from '../models/budget.model';
import { WGSSubscriptionDetail, WGSSubscriptionDetailsItemViewModel } from '../models/wgs.model';
import { DDCustomer } from '../models/customer.model';
import { CirrusSubscriptionModel } from '../models/veeam.model';
import { CustomerService } from './customer.service';
import { Router } from '@angular/router';
import { CommonService } from './common.service';


@Injectable()
export class ManageService {
  private controller = 'Manage';
  base_url = 'Manage';
  pageNo = 1;
  manageViewScope: any | boolean = false;
  program: ManageByProgram;
  pendingChanges: PendingChangeModel[] = [];
  details: ADKDetailsViewModel = {} as ADKDetailsViewModel;
  kaspdetails: ADKDetailsViewModel = {} as ADKDetailsViewModel;
  cirrusdetails: ADKDetailsViewModel = {} as ADKDetailsViewModel;
  adkdetails: ADKDetailsViewModel = {} as ADKDetailsViewModel;
  intadetails: SubscriptionDetailsViewModel = null;
  spladetails: AnnuityDetailsViewModel = null;
  pendingSubscriptions: AnnuityItemsViewModel[] = [];
  pendingAddon: AnnuityItemsViewModel[] = [];
  pendingKaspSubscriptions: AnnuityItemsViewModel[] = [];
  pendingCirrusSubscriptions: AnnuityItemsViewModel[] = [];
  pendingPerpetualItems: CSPPerpetualItemsViewModel[] = [];
  pendingAzureRi: CSPPerpetualItemsViewModel[] = [];
  pendingSoftware: CSPPerpetualItemsViewModel[] = [];
  tenantResponse: TenantResponse = {} as TenantResponse;
  ADKpendingSubscriptions: CSPModifySubscriptionViewModel[] = [];
  ADKADYpendingSubscriptions: CSPModifySubscriptionViewModel[] = [];
  public currentProductPricingV2: GetProductPricingV2;

  updateDigiwalWalletSubject: Subject<void> = new Subject<void>();
  // false = get, true = refresh
  public getOrRefreshSubscriptionOrderSubject: Subject<boolean> = new Subject<boolean>();
  public getOrRefreshProgramsSubject: Subject<void> = new Subject<void>();
  renewalsTitle: EventEmitter<string> = new EventEmitter<string>();
  refetchCSPItemsView$: Subject<void> = new Subject<void>();
  refetchWGSItemsView$: Subject<void> = new Subject<void>();
  updateWGSdetailView$: Subject<WGSSubscriptionDetail> = new Subject<WGSSubscriptionDetail>();
  refetchSoftwareSubscription$: Subject<void> = new Subject<void>();
  refetchBudgetList$: Subject<void> = new Subject<void>();

  status: boolean = true;

  // tslint:disable-next-line:member-ordering
  public static agreement_validation_messages: any = {
    firstName: [{ class: 'firstName', message: 'Please enter first name' }],
    lastName: [{ class: 'lastName', message: 'Please enter last name' }],
    email: [{ class: 'email', message: 'Please enter email address' }],
    phone: [{ class: 'phone', message: 'Please enter phone number' }],
  };

  public subscriptionTypes: DickerSelectListItem[] = [];

  private watchSearchSubject = new BehaviorSubject<string>('');
  currentWatch = this.watchSearchSubject.asObservable();

  private softwareSubscription = new BehaviorSubject<any>({});
  currentSoftwareSubscription = this.softwareSubscription.asObservable();

  private watchVendorSubject = new BehaviorSubject<string>('');
  currentVendorWatch = this.watchVendorSubject.asObservable();

  private watchValueSubject = new BehaviorSubject<string>('');
  currentValueWatch = this.watchValueSubject.asObservable();

  private watchContractSubject = new BehaviorSubject<string>('');
  currentContractWatch = this.watchContractSubject.asObservable();

  private watchSelectedTabIndex = new BehaviorSubject<number>(0);
  currentSelectedTabIndex = this.watchSelectedTabIndex.asObservable();

  private watchCurrentAnnuityList = new BehaviorSubject<AnnuityViewModel[]>(null);
  currentAnnuityList = this.watchCurrentAnnuityList.asObservable();

  private detailsSubject = new BehaviorSubject<ADKDetailsViewModel>(
    this.details
  );
  currentDetailsWatch = this.detailsSubject.asObservable();

  private annuitySubject = new BehaviorSubject<TenantResponse>(
    this.tenantResponse
  );
  currentAnnuityWatch = this.annuitySubject.asObservable();

  private kaspdetailsSubject = new BehaviorSubject<ADKDetailsViewModel>(
    this.kaspdetails
  );
  currentKaspDetailsWatch = this.kaspdetailsSubject.asObservable();

  private cirrusdetailsSubject = new BehaviorSubject<ADKDetailsViewModel>(
    this.cirrusdetails
  );
  currentCirrusDetailsWatch = this.cirrusdetailsSubject.asObservable();

  private adkdetailsSubject = new BehaviorSubject<ADKDetailsViewModel>(
    this.adkdetails
  );
  currentADKDetailsWatch = this.adkdetailsSubject.asObservable();

  private intadetailssubject = new BehaviorSubject<
    SubscriptionDetailsViewModel
  >(this.intadetails);
  currentINTADetailsWatch = this.intadetailssubject.asObservable();

  private spladetailssubject = new BehaviorSubject<AnnuityDetailsViewModel>(
    this.spladetails
  );
  currentSPLADetailsWatch = this.spladetailssubject.asObservable();

  private pendingChangeSubject = new BehaviorSubject<PendingChangeModel[]>(
    this.pendingChanges
  );
  currentPendingChange = this.pendingChangeSubject.asObservable();

  private watchPendingSubscriptions = new BehaviorSubject<
    AnnuityItemsViewModel[]
  >(this.pendingSubscriptions);
  currentPendingSubscriptions = this.watchPendingSubscriptions.asObservable();
  
  private watchPendingWGSSubscriptions = new BehaviorSubject<AnnuityItemsViewModel[]>(this.pendingSubscriptions);
  public currentPendingWGSSubscriptions = this.watchPendingWGSSubscriptions.asObservable();

  private watchPendingAzureSubscriptions = new BehaviorSubject<
    AnnuityItemsViewModel[]
  >([]);
  currentPendingAzureSubscriptions = this.watchPendingAzureSubscriptions.asObservable();

  private watchPendingAddon = new BehaviorSubject<AnnuityItemsViewModel[]>(
    this.pendingAddon
  );
  currentPendingAddon = this.watchPendingAddon.asObservable();

  private watchPendingKaspSubscriptions = new BehaviorSubject<
    AnnuityItemsViewModel[]
  >(this.pendingKaspSubscriptions);
  currentPendingKaspSubscriptions = this.watchPendingKaspSubscriptions.asObservable();

  private watchPendingCirrusSubscriptions = new BehaviorSubject<
    AnnuityItemsViewModel[]
  >(this.pendingCirrusSubscriptions);
  currentPendingCirrusSubscriptions = this.watchPendingCirrusSubscriptions.asObservable();

  private watchPendingPerpetualItems = new BehaviorSubject<
    CSPPerpetualItemsViewModel[]
  >(this.pendingPerpetualItems);
  currentPendingPerpetualItems = this.watchPendingPerpetualItems.asObservable();

  private watchPendingAzureRi = new BehaviorSubject<
    CSPPerpetualItemsViewModel[]
  >(this.pendingAzureRi);
  currentPendingAzureRi = this.watchPendingAzureRi.asObservable();

  private watchPendingSoftware = new BehaviorSubject<
    CSPPerpetualItemsViewModel[]
  >(this.pendingSoftware);
  currentPendingSoftware = this.watchPendingSoftware.asObservable();

  private watchPendingSpla = new BehaviorSubject<boolean>(false);
  currentPendingSpla = this.watchPendingSpla.asObservable();

  private watchProgramType = new BehaviorSubject<string>('');
  currentProgramType = this.watchProgramType.asObservable();

  private watchBillingInfo = new Subject<string>();
  currentBillingInfo = this.watchBillingInfo.asObservable();

  private watchADKPendingSubscriptions = new BehaviorSubject<
    CSPModifySubscriptionViewModel[]
  >(this.ADKpendingSubscriptions);
  currentADKPendingSubscriptions = this.watchADKPendingSubscriptions.asObservable();

  private watchADKADYPendingSubscriptions = new BehaviorSubject<
    CSPModifySubscriptionViewModel[]
  >(this.ADKADYpendingSubscriptions);
  currentADKADYPendingSubscriptions = this.watchADKADYPendingSubscriptions.asObservable();

  private watchMPNIDCheckPending = new BehaviorSubject<Boolean>(this.status);
  currentMPNIDCheckPendingValue = this.watchMPNIDCheckPending.asObservable();

  private watchCSPPurchase = new BehaviorSubject<string>('');
  currentCSPPurchase = this.watchCSPPurchase.asObservable();

  private watchSoftwareConfirm = new BehaviorSubject<string>('');
  currentSoftwareConfirmValue = this.watchSoftwareConfirm.asObservable();

  private watchAzureRIConfirm = new BehaviorSubject<string>('');
  currentAzureRIConfirmValue = this.watchAzureRIConfirm.asObservable();

  private watchSubscriptionConfirm = new BehaviorSubject<string>('');
  currentSubscriptionConfirmValue = this.watchSubscriptionConfirm.asObservable();

  private watchAzureSubscriptionConfirm = new BehaviorSubject<string>('');
  currentAzureSubscriptionConfirmValue = this.watchAzureSubscriptionConfirm.asObservable();

  private watchMPNList = new BehaviorSubject<string[]>([]);
  currentMPNList = this.watchMPNList.asObservable();

  private watchExistingCSPSubscriptions = new BehaviorSubject<CSPSubscriptions[]>(null);
  currentExistingCSPSubscriptions = this.watchExistingCSPSubscriptions.asObservable();

  private watchMCESubscriptionUpgrade = new BehaviorSubject<MCEUpgradeModel>(null);
  currentMCESubscriptionUpgrade = this.watchMCESubscriptionUpgrade.asObservable();

  private watchSoftwareMPN = new BehaviorSubject<{ mpn: string, check: boolean }>({ mpn: '', check: true });
  currentSoftwareMPN = this.watchSoftwareMPN.asObservable();

  private watchAzureRiMPN = new BehaviorSubject<{ mpn: string, check: boolean }>({ mpn: '', check: true });
  currentAzureRiMPN = this.watchAzureRiMPN.asObservable();

  private watchPaymentDetails = new BehaviorSubject<PaymentDetails>({ purchaseAccess: '', digitalWalletId: '' });
  currentPaymentDetails = this.watchPaymentDetails.asObservable();

  private watchDetailsView = new BehaviorSubject<string>('');
  currentDetailsView = this.watchDetailsView.asObservable();

  private renewalDetail = new BehaviorSubject<any>(null);
  currentRenewlDetail = this.renewalDetail.asObservable();

  private cspTenantDetails = new BehaviorSubject<any>(null);
  currentCSPTenantDetails = this.cspTenantDetails.asObservable();

  private kaspTenantDetails = new BehaviorSubject<any>(null);
  currentKASPTenantDetails = this.kaspTenantDetails.asObservable();

  private cirrusTenantDetails = new BehaviorSubject<any>(null);
  currentCirrusTenantDetails = this.cirrusTenantDetails.asObservable();

  private vendorDictionary = new BehaviorSubject<any>({});
  currentVendorDictionary = this.vendorDictionary.asObservable();

  private configureEndUserStatus = new Subject<{ status: boolean, tenantId: string, tab?: string }>();
  currentConfigureEndUserStatus = this.configureEndUserStatus.asObservable();

  private endUserUpdateStatus = new Subject<string>();
  currentEndUserUpdateStatus = this.endUserUpdateStatus.asObservable();

  private tenantEndUsers = new BehaviorSubject<CSPTenantUser[]>([]);
  currentTenantEndUsers = this.tenantEndUsers.asObservable();

  public WGSSubscriptionDetail = new BehaviorSubject<WGSSubscriptionDetail>(null);
  public currentWGSSubscriptionDetail = this.WGSSubscriptionDetail.asObservable();

  private watchBudgetSubject = new BehaviorSubject<any>({});
  public currentBudgetDetail = this.watchBudgetSubject.asObservable();

  public cspReservedInstanceItemsCount$ = new BehaviorSubject<number>(0);

  public addonPendingList$: BehaviorSubject<{ subscriptionId: string, addons: AnnuityItemsViewModel[] }> = new BehaviorSubject(null);

  public upgradeSubscriotionfrom$: BehaviorSubject<GetCSPSubscription> = new BehaviorSubject(null)

  public upgradeSubscriotionto$: BehaviorSubject<TransitionEligibility> = new BehaviorSubject(null)

  private cspSoftware = new Subject<CSPCustomerEntitlementsViewModel>();
  public currentCSPSoftware = this.cspSoftware.asObservable();

  private cspReservedInstance = new Subject<CSPCustomerEntitlementsViewModel>();
  public currentReservedInstance = this.cspReservedInstance.asObservable();

  public _softwareTabClick$: Subject<boolean> = new Subject<boolean>();

  private watchWGSContractResellerId = new BehaviorSubject<string>('');
  public getCurrentWGSContractResellerId = this.watchWGSContractResellerId.asObservable();
  public setCurrentWGSContractResellerId(id: string) {
    this.watchWGSContractResellerId.next(id);
  }

  private watchNCERenewalPendingList = new BehaviorSubject<SubscriptionAction[]>([]);
  public getCurrentNCERenewalPendingList = this.watchNCERenewalPendingList.asObservable();
  public setCurrentNCERenewalPendingList(list: SubscriptionAction[]) {
    this.watchNCERenewalPendingList.next(list);
  }

  private watchCSPProductList = new BehaviorSubject<AnnuityItemsViewModel[]>([]);
  public getCurrentCSPProductList = this.watchCSPProductList.asObservable();
  public setCurrentCSPProductList(list: AnnuityItemsViewModel[]) {
    this.watchCSPProductList.next(list);
  }

  constructor(
    private http: HttpClient,
    private router: Router,
    private customerService: CustomerService,
    private authService: AuthService,
    private cs: CommonService
  ) { }

  monitorCurrentCSPReservedInstance(sub: CSPCustomerEntitlementsViewModel) {
    this.cspReservedInstance.next(sub);
  }

  monitorCurrentCSPSoftware(sub: CSPCustomerEntitlementsViewModel) {
    this.cspSoftware.next(sub);
  }

  monitorCurrentAnnuityList(annuities: AnnuityViewModel[]) {
    this.watchCurrentAnnuityList.next(annuities);
  }

  monitorCurrentEndUserUpdateStatus(value: string) {
    this.endUserUpdateStatus.next(value);
  }

  monitorCurrentTenantEndUsers(value: CSPTenantUser[]) {
    this.tenantEndUsers.next(value);
  }

  monitorConfigureEndUserStatus(value: { status: boolean, tenantId: string, tab?: string }) {
    this.configureEndUserStatus.next(value);
  }

  monitorVendorDictionary(vendorDictionary: any) {
    this.vendorDictionary.next(vendorDictionary);
  }

  monitorCSPTenantDetails(customer: GetCSPTenant) {
    this.cspTenantDetails.next(customer);
  }

  monitorKASPTenantDetails(customer: GetCSPTenant) {
    this.kaspTenantDetails.next(customer);
  }

  monitorCirrusTenantDetails(customer: GetCSPTenant) {
    this.cirrusTenantDetails.next(customer);
  }

  monitorRenewalDetailsUpdate(details: any) {
    this.renewalDetail.next(details);
  }

  monitorDetailsView(detailsView: string): void {
    this.watchDetailsView.next(detailsView);
  }

  monitorCurrentPaymentDetails(details: PaymentDetails): void {
    this.watchPaymentDetails.next(details);
  }

  monitorSoftwareMPN(value: { mpn: string, check: boolean }) {
    this.watchSoftwareMPN.next(value);
  }

  monitorAzureRiMPN(value: { mpn: string, check: boolean }) {
    this.watchAzureRiMPN.next(value);
  }

  monitorMPNList(value: string[]): void {
    this.watchMPNList.next(value);
  }

  monitorExistingCSPSubscrptions(value: CSPSubscriptions[]) {
    this.watchExistingCSPSubscriptions.next(value);
  }

  monitorMCESubscriptionUpgrade(value: MCEUpgradeModel) {
    value.isRenewLoaded = false;
    if (!this.cs.isNil(value.autoRenewalEnabled) && !this.cs.isNil(value.changeToQty) && !this.cs.isNil(value.billingCycle) && !this.cs.isNil(value.termDuration) && !this.cs.isNil(value.from) && !this.cs.isNil(value.to)) {
      value.isRenewLoaded = true;
    }
    this.watchMCESubscriptionUpgrade.next(value);
  }

  monitorSoftwareConfirmValue(value: string): void {
    this.watchSoftwareConfirm.next(value);
  }

  monitorAzureRIConfirmValue(value: string): void {
    this.watchAzureRIConfirm.next(value);
  }

  monitorSubscriptionConfirmValue(value: string): void {
    this.watchSubscriptionConfirm.next(value);
  }

  monitorAzureSubscriptionConfirmValue(value: string): void {
    this.watchAzureSubscriptionConfirm.next(value);
  }

  monitorCSPPurchase(purchase: string): void {
    this.watchCSPPurchase.next(purchase);
  }

  monitorBillingInfo(ProgramType: string): void {
    this.watchBillingInfo.next(ProgramType);
  }

  monitorMPNIDCheckStatus(Status: Boolean): void {
    this.watchMPNIDCheckPending.next(Status);
  }

  monitorProgramType(ProgramType: string): void {
    this.watchProgramType.next(ProgramType);
  }

  monitorPendingSubscriptions(pendingList: AnnuityItemsViewModel[]): void {
    this.watchPendingSubscriptions.next(pendingList);
  }

  monitorPendingWGSSubscriptions(pendingList: AnnuityItemsViewModel[]): void {
    this.watchPendingWGSSubscriptions.next(pendingList);
  }

  monitorPendingAzureSubscriptions(pendingList: AnnuityItemsViewModel[]): void {
    this.watchPendingAzureSubscriptions.next(pendingList);
  }

  monitorADKPendingSubscriptions(
    ADKpendingList: CSPModifySubscriptionViewModel[]
  ): void {
    this.watchADKPendingSubscriptions.next(ADKpendingList);
  }
  monitorADKADYPendingSubscriptions(
    ADKADYpendingList: CSPModifySubscriptionViewModel[]
  ): void {
    this.watchADKADYPendingSubscriptions.next(ADKADYpendingList);
  }
  monitorPendingSpla(pending: boolean): void {
    this.watchPendingSpla.next(pending);
  }

  monitorPendingAddon(pendingList: AnnuityItemsViewModel[]): void {
    this.watchPendingAddon.next(pendingList);
  }

  monitorAnnuity(pending: TenantResponse): void {
    this.annuitySubject.next(pending);
  }

  monitorPendingKaspSubscriptions(pendingList: AnnuityItemsViewModel[]): void {
    this.watchPendingKaspSubscriptions.next(pendingList);
  }

  monitorPendingCirrusSubscriptions(pendingList: AnnuityItemsViewModel[]): void {
    this.watchPendingCirrusSubscriptions.next(pendingList);
  }

  monitorPendingPerpetualItems(
    pendingList: CSPPerpetualItemsViewModel[]
  ): void {
    this.watchPendingPerpetualItems.next(pendingList);
  }

  monitorPendingAzureRi(pendingList: CSPPerpetualItemsViewModel[]): void {
    this.watchPendingAzureRi.next(pendingList);
  }

  monitorPendingSoftware(pendingList: CSPPerpetualItemsViewModel[]): void {
    this.watchPendingSoftware.next(pendingList);
  }

  monitorSearchKeyWordChange(searchKeyWord: string): void {
    this.watchSearchSubject.next(searchKeyWord);
  }

  monitorSelectedTabIndex(index: number): void {
    this.watchSelectedTabIndex.next(index);
  }

  monitorPendingChange(pendingChanges: PendingChangeModel[]): void {
    this.pendingChangeSubject.next(pendingChanges);
  }

  monitorDetailsChange(details: ADKDetailsViewModel): void {
    this.detailsSubject.next(details);
  }

  monitorKaspDetailsChange(details: ADKDetailsViewModel): void {
    this.kaspdetailsSubject.next(details);
  }

  monitorCirrusDetailsChange(details: ADKDetailsViewModel): void {
    this.cirrusdetailsSubject.next(details);
  }

  monitorINTADetailsChange(details: SubscriptionDetailsViewModel): void {
    this.intadetailssubject.next(details);
  }

  monitorSPLADetailsChange(details: AnnuityDetailsViewModel): void {
    this.spladetailssubject.next(details);
  }

  monitorADKDetailsChange(details: ADKDetailsViewModel): void {
    this.adkdetailsSubject.next(details);
  }

  monitorVendorChange(Vendor: string): void {
    this.watchVendorSubject.next(Vendor);
  }
  sendCurrentSoftwareSubscription(sub: any): void {
    this.softwareSubscription.next(sub);
  }
  monitorValueChange(Value: string): void {
    this.watchValueSubject.next(Value);
  }
  monitorContractChange(Contract: string): void {
    this.watchContractSubject.next(Contract);
  }
  monitorCurrentBudget(Budget: any): void {
    this.watchBudgetSubject.next(Budget);
  }

  getSubscriptionPrograms(): Observable<SubscriptionPrograms> {
    return this.http
      .get<SubscriptionPrograms>(this.base_url + '/GetSubscriptionPrograms')
      .pipe(catchError(this.authService.handleError));
  }

  getRenewalPrograms(): Observable<ManageByProgram[]> {
    return this.http
      .get<ManageByProgram[]>(this.base_url + '/GetRenewalPrograms')
      .pipe(catchError(this.authService.handleError));
  }

  getLTEDetails(
    orderNo: string,
    orderSuffix: string,
    programType: string,
    renewalDate: string
  ): Observable<LTEDetailsViewModel> {
    return this.http
      .get<LTEDetailsViewModel>(
        this.base_url +
        '/GetLTEDetails?orderNo=' +
        orderNo +
        '&orderSuffix=' +
        orderSuffix +
        '&programType=' +
        programType +
        '&renewalDate=' +
        renewalDate
      )
      .pipe(catchError(this.authService.handleError));
  }

  getLTEItemsView(
    orderNo: string,
    orderSuffix: string,
    renewalDate: string,
    status: string
  ): Observable<LTEDetailsItems> {
    return this.http
      .get<LTEDetailsItems>(
        this.base_url +
        '/GetLTEItemsView?orderNo=' +
        orderNo +
        '&orderSuffix=' +
        orderSuffix +
        '&renewalDate=' +
        renewalDate +
        '&status=' +
        status
      )
      .pipe(catchError(this.authService.handleError));
  }

  getLTEOrders(
    euName?: string,
    programType?: string,
    expiryStart?: string,
    expiryEnd?: string
  ): Observable<AnnuityViewModel[]> {
    return this.http
      .get<AnnuityViewModel[]>(
        this.base_url +
        '/GetLTEOrders?euName=' +
        euName +
        '&programType=' +
        programType +
        '&expiryStart=' +
        expiryStart +
        '&expiryEnd=' +
        expiryEnd
      )
      .pipe(catchError(this.authService.handleError));
  }

  confirmLTE(
    orderNo: string,
    orderSuffix: string,
    expDate?: string
  ): Observable<any> {
    return this.http
      .get(
        this.base_url +
        '/ConfirmLTE?orderNo=' +
        orderNo +
        '&orderSuffix=' +
        orderSuffix +
        '&expDate=' +
        expDate
      )
      .pipe(catchError(this.authService.handleError));
  }

  getXRenewalsList(startDate: string, endDate: string): Observable<any> {
    return this.http.get(this.base_url + '/GetXRenewalList?startDate=' + startDate + '&endDate=' + endDate).pipe(catchError(this.authService.handleError));
  }

  GetRenewalDetails(serial): Observable<any> {
    return this.http.get(this.base_url + '/GetRenewalDetails?serial=' + serial).pipe(catchError(this.authService.handleError));
  }

  quoteOrders(quoteId: string, version: string, expiryDate: string, items: QuoteOrderItem[]): Observable<any> {
    return this.http.post(`${this.base_url}/QuoteOrders/${quoteId}/${version}/${expiryDate}`, items)
      .pipe(catchError(this.authService.handleError));
  }

  purchase(model: LTEPurchaseViewModel): Observable<any> {
    return this.http
      .post(this.base_url + '/Purchase', model)
      .pipe(catchError(this.authService.handleError));
  }

  Enquiry(detail: any, management: any, model: any, message: string, desc: string): Observable<any> {
    return this.http
      .post(this.base_url + '/Enquiry', { detail: detail, management: management, purchaseViewMode: model, enquiry: message, description: desc })
      .pipe(catchError(this.authService.handleError));
  }

  getPerpetualsByType(programType: string): Observable<ManageByPerpetual[]> {
    return this.http
      .get<ManageByPerpetual[]>(this.base_url + '/GetPerpetualsByType?programType=' + programType)
      .pipe(catchError(this.authService.handleError));
  }

  getSubscriptionOrders(
    pageView: string,
    programType?: string,
    expiryStart?: string,
    expiryEnd?: string
  ): Observable<AnnuityListViewModel> {
    return this.http
      .get<AnnuityListViewModel>(
        this.base_url +
        '/GetSubscriptionOrders?pageView=' +
        pageView +
        '&programType=' +
        programType +
        '&expiryStart=' +
        expiryStart +
        '&expiryEnd=' +
        expiryEnd
      )
      .pipe(catchError(this.authService.handleError));
  }

  getADKDetails(
    tenantId: string,
    programType: string,
    orderId?: string,
    annuityId?: string
  ): Observable<ADKDetailsViewModel> {
    return this.http
      .get<ADKDetailsViewModel>(
        this.base_url +
        '/GetADKDetails?tenantId=' +
        tenantId +
        '&programType=' +
        programType +
        '&orderId=' +
        orderId +
        '&annuityId=' +
        annuityId
      )
      .pipe(catchError(this.authService.handleError));
  }

  getADKItemsView(
    tenantId: string,
    programType: string
  ): Observable<ADKDetailsItemViewModel> {
    return this.http
      .get<ADKDetailsItemViewModel>(
        this.base_url +
        '/GetADKItemsView?tenantId=' +
        tenantId +
        '&programType=' +
        programType
      )
      .pipe(catchError(this.authService.handleError));
  }

  getADKItems(tenantId: string, programType: string): Observable<I_AnnuityItemsViewModel[]> {
    return this.http.get<I_AnnuityItemsViewModel[]>(this.base_url + '/GetADKItems?tenantId=' + tenantId
        + '&programType=' + programType
      )
        .pipe(catchError(this.authService.handleError))
        .pipe(map((items) => items.map(item => new AnnuityItemsViewModel(item))));
  }

  getItemList(annuityId: string, programType: string, orderNo: string, orderSuffix: string): Observable<I_AnnuityItemsViewModel[]> {
    return this.http.get<I_AnnuityItemsViewModel[]>(this.base_url + '/GetItemList?annuityId=' + annuityId 
        + '&programType=' + programType
        + '&orderNo=' + orderNo
        + '&orderSuffix=' + orderSuffix
      )
        .pipe(catchError(this.authService.handleError))
        .pipe(map((items) => items.map(item => new AnnuityItemsViewModel(item))));
  }

  addAnnuityItem(
    stockCode: string,
    orderNo: string,
    orderSuffix: string,
    annuityId: string,
    lineSeq: string,
    qty: string
  ): Observable<any> {
    return this.http
      .get(
        this.base_url +
        '/AddAnnuityItem?stockCode=' +
        stockCode +
        '&orderNo=' +
        orderNo +
        '&orderSuffix=' +
        orderSuffix +
        '&annuityId=' +
        annuityId +
        '&lineSeq=' +
        lineSeq +
        '&qty=' +
        qty
      )
      .pipe(catchError(this.authService.handleError));
  }

  getSubscriptionDetails(
    tenantId: string,
    programType: string
  ): Observable<SubscriptionDetailsViewModel> {
    return this.http
      .get<SubscriptionDetailsViewModel>(
        this.base_url +
        '/GetSubscriptionDetails?tenantId=' +
        tenantId +
        '&programType=' +
        programType
      )
      .pipe(catchError(this.authService.handleError));
  }

  getSubscriptionItemsView(
    tenantId: string,
    programType: string
  ): Observable<SubscriptionDetailsItemViewModel> {
    return this.http
      .get<SubscriptionDetailsItemViewModel>(
        this.base_url +
        '/GetSubscriptionItemsView?tenantId=' +
        tenantId +
        '&programType=' +
        programType
      )
      .pipe(catchError(this.authService.handleError));
  }

  getSubscriptionItems(tenantId: string, billingFreq?: string, programType?: string): Observable<I_AnnuityItemsViewModel[]> {
    return this.http.get<I_AnnuityItemsViewModel[]>(this.base_url + '/GetSubscriptionItems?tenantId=' + tenantId 
        + '&billingFreq=' + billingFreq
        + '&programType=' + programType
      )
        .pipe(catchError(this.authService.handleError))
        .pipe(map((items) => items.map(item => new AnnuityItemsViewModel(item))));
  }

  saveLineEndUser(
    orderNo: string,
    orderSuffix: string,
    euText: string,
    lineSeq: string
  ): Observable<any> {
    return this.http
      .get(
        this.base_url +
        '/SaveLineEndUser?orderNo=' +
        orderNo +
        '&orderSuffix=' +
        orderSuffix +
        '&euText=' +
        euText +
        '&lineSeq=' +
        lineSeq
      )
      .pipe(catchError(this.authService.handleError));
  }

  confirmAnnuityOrder(
    annuityId: string,
    orderNo: string,
    orderSuffix: string,
    nextCustRef: string
  ): Observable<any> {
    return this.http
      .get(
        this.base_url +
        '/ConfirmAnnuityOrder?annuityId=' +
        annuityId +
        '&orderNo=' +
        orderNo +
        '&orderSuffix=' +
        orderSuffix +
        '&nextCustRef=' +
        nextCustRef
      )
      .pipe(catchError(this.authService.handleError));
  }

  cancelContract(tenantId: string, tenantType: string): Observable<any> {
    return this.http
      .get(
        this.base_url +
        '/CancelContract?tenantId=' +
        tenantId +
        '&tenantType=' +
        tenantType
      )
      .pipe(catchError(this.authService.handleError));
  }

  exportExcelForAnnuities(
    keyword: string,
    pageView: string,
    startDate: string,
    endDate: string
  ): Observable<any> {
    return this.http
      .get(
        '/api/ExportExcel/exportannuitiestoexcel?keyword=' +
        keyword +
        '&pageView=' +
        pageView +
        '&startDate=' +
        startDate +
        '&endDate=' +
        endDate,
        {
          responseType: 'blob',
          headers: {
            Accept:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
          },
        }
      )
      .pipe(catchError(this.authService.handleError));
  }

  public exportNCEMigrationReport(tenantId: string): Observable<any> {
    return this.http.get(
      '/api/ExportExcel/ExportNCEMigrationReport?tenantId=' +
      tenantId,
      {
        responseType: 'blob',
        headers: {
          Accept:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
        },
      }
    )
      .pipe(catchError(this.authService.handleError));
  }

  ExportOpenOrder(orderList: Order[]): Observable<any> {
    return this.http
      .post('/api/ExportExcel/ExportOpenOrder', orderList, {
        responseType: 'blob',
        headers: {
          Accept:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
        },
      })
      .pipe(catchError(this.authService.handleError));
  }

  ExportOpenOrdersLink(): Observable<any> {
    return this.http
      .get('/api/ExportExcel/GetOpenOrdersLink')
      .pipe(catchError(this.authService.handleError));
  }

  ExportInvoicedOrder(
    orderList: Order[],
    search: boolean = false
  ): Observable<any> {
    return this.http
      .post(
        '/api/ExportExcel/ExportInvoicedOrder?search=' + search,
        orderList,
        {
          responseType: 'blob',
          headers: {
            Accept:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
          },
        }
      )
      .pipe(catchError(this.authService.handleError));
  }

  ExportInvoicedOrderLink(fileName: string): Observable<any> {
    return this.http
      .get('/api/ExportExcel/ExportInvoicedOrderLink?fileName=' + fileName)
      .pipe(catchError(this.authService.handleError));
  }

  ExportRenewalsLink(fileName: string): Observable<any> {
    return this.http
      .get('/api/ExportExcel/ExportRenewalsLink?fileName=' + fileName)
      .pipe(catchError(this.authService.handleError));
  }

  exportAnnuitySKUPriceList(stockTypeCode: string): Observable<any> {
    return this.http
      .get(
        '/api/ExportExcel/exportannuityskupricelist?stksalestypecode=' +
        stockTypeCode,
        {
          responseType: 'blob',
          headers: {
            Accept:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
          },
        }
      )
      .pipe(catchError(this.authService.handleError));
  }

  getSubscriptionList(): Observable<ManageByProgram[]> {
    return this.http
      .get<ManageByProgram[]>(this.base_url + '/GetSubscriptionList')
      .pipe(catchError(this.authService.handleError));
  }

  createOrUpdateCSPSubscription(model: CSPModifySubscriptionViewModel[]): Observable<CSPModifySubscriptionResponse[]> {

    // change empty mpn to 'NOMPNID' for legacy 
    const subs = [...model]
    for (var s of subs) {
      if (s?.chargeType === 'SEAT' && s?.mpnId === '') {
        s.mpnId = 'NOMPNID'
      }
    }

    return this.http
      .post<CSPModifySubscriptionResponse[]>(this.base_url + '/CreateOrUpdateCSPSubscription', model)
      .pipe(catchError(this.authService.handleError));
  }



  createOrUpdateKASPSubscription(
    model: CSPModifySubscriptionViewModel[]
  ): Observable<CSPModifySubscriptionResponse[]> {
    return this.http
      .post<CSPModifySubscriptionResponse[]>(this.base_url + '/CreateOrUpdateKASPSubscription', model)
      .pipe(catchError(this.authService.handleError));
  }

  createCirrusSubscription(
    model: CirrusSubscriptionModel[]
  ): Observable<CSPModifySubscriptionResponse[]> {
    return this.http
      .post<CSPModifySubscriptionResponse[]>(this.base_url + '/CreateCirrusVeeamSubscription', model)
      .pipe(catchError(this.authService.handleError));
  }

  CreateCirrusTenantSubscription(formCollection: any): Observable<CirrusTenantResponse> {
    const formData = new FormData();
    formData.append('formCollection', formCollection);
    return this.http.post<CirrusTenantResponse>(this.base_url + '/CreateCirrusVeeamTenantSubscription', formData)
      .pipe(catchError(this.authService.handleError));
  }

  cancelCirrusSubscription( model: CirrusSubscriptionModel): Observable<CirrusCancelSubscriptionResponse> {
    return this.http
      .post<CirrusCancelSubscriptionResponse>(this.base_url + '/CancelCirrusVeeamSubscription', model)
      .pipe(catchError(this.authService.handleError));
  }


  addWGSProduct(model: WGSubscriptionModel[]): Observable<WGSubscriptionResponse[]> {
    return this.http
      .post<WGSubscriptionResponse[]>(this.base_url + '/AddWGSProduct', model)
      .pipe(catchError(this.authService.handleError));
  }

  getSPLADetails(
    annuityId: string,
    orderNo: string,
    orderSuffix: string,
    renewalCode: string
  ): Observable<AnnuityDetailsViewModel> {
    return this.http
      .get<AnnuityDetailsViewModel>(
        this.base_url +
        '/GetSPLADetails?annuityId=' +
        annuityId +
        '&orderNo=' +
        orderNo +
        '&orderSuffix=' +
        orderSuffix +
        '&renewalCode=' +
        renewalCode
      )
      .pipe(catchError(this.authService.handleError));
  }

  getAnnuityItems(
    nextOrderNo: string,
    nextOrderSuffix: string,
    currentOrderNo: string,
    currentOrderSuffix: string,
    accountId: string
  ): Observable<AnnuityItems> {
    return this.http
      .get<AnnuityItems>(
        this.base_url +
        '/GetAnnuityItems?nextOrderNo=' +
        nextOrderNo +
        '&nextOrderSuffix=' +
        nextOrderSuffix +
        '&currentOrderNo=' +
        currentOrderNo +
        '&currentOrderSuffix=' +
        currentOrderSuffix +
        '&accountId=' +
        accountId
      )
      .pipe(catchError(this.authService.handleError));
  }

  GetMSCloudAgreementStatus(
    tenantId: string
  ): Observable<SubscriptionApiResponse> {
    return this.http
      .get<SubscriptionApiResponse>(this.base_url + '/GetMSCloudAgreementStatus?tenantId=' + tenantId)
      .pipe(catchError(this.authService.handleError));
  }

  updateMSCloudAgreement(
    formData: string
  ): Observable<SubscriptionApiResponse> {
    return this.http
      .get<SubscriptionApiResponse>(this.base_url + '/UpdateMSCloudAgreement?formData=' + formData)
      .pipe(catchError(this.authService.handleError));
  }

  getTenantManagementLinks(tenantId: string): Observable<ManagementLink[]> {
    return this.http
      .get<ManagementLink[]>(this.base_url + '/GetTenantManagementLinks?tenantId=' + tenantId)
      .pipe(catchError(this.authService.handleError));
  }

  GetCSPItemsView(tenantId: string): Observable<CSPDetailsItemViewModel> {
    return this.http
      .get<CSPDetailsItemViewModel>(this.base_url + '/GetCSPItemsView?tenantId=' + tenantId)
      .pipe(catchError(this.authService.handleError));
  }


  GetCSPItemsFromMicrosoft(tenantId: string, targetView?: string, subscriptionType?: string): Observable<I_AnnuityItemsViewModel[]> {
    return this.http.get<I_AnnuityItemsViewModel[]>(this.base_url + '/GetCSPItemsFromMicrosoft?tenantId=' + tenantId
        + '&targetView=' + targetView
        + '&subscriptionType=' + subscriptionType
      )
        .pipe(catchError(this.authService.handleError))
        .pipe(map((items) => items.map(item => new AnnuityItemsViewModel(item))));
  }

  GetKASPItemsView(tenantId: string): Observable<CSPDetailsItemViewModel> {
    return this.http.get<CSPDetailsItemViewModel>(this.base_url + '/GetKASPItemsView?tenantId=' + tenantId)
      .pipe(catchError(this.authService.handleError));
  }

  GetKASPChildSKU(
    base_sku: string,
    qty: number
  ): Observable<KASPChildSKUModel> {
    return this.http
      .get<KASPChildSKUModel>(
        this.base_url + '/GetKASPChildSKU?base_sku=' + base_sku + '&qty=' + qty
      )
      .pipe(catchError(this.authService.handleError));
  }

  GetCirrusItemsView(tenantId: string): Observable<CSPDetailsItemViewModel> {
    return this.http
      .get<CSPDetailsItemViewModel>(this.base_url + '/GetCirrusItemsView?tenantId=' + tenantId)
      .pipe(catchError(this.authService.handleError));
  }
 

  GetDefaultMPN(): Observable<string[]> {
    return this.http
      .get<string[]>(this.base_url + '/GetDefaultMPN')
      .pipe(catchError(this.authService.handleError));
  }

  GetAzureLocationList(): Observable<CspAzureLocationModel[]> {
    return this.http
      .get<CspAzureLocationModel[]>(this.base_url + '/GetAzureLocationList')
      .pipe(catchError(this.authService.handleError));
  }

  GetCSPAddonItems(
    baseStockCode: string,
    subscriptionId: string
  ): Observable<AnnuityItemsViewModel[]> {
    return this.http
      .get<AnnuityItemsViewModel[]>(
        this.base_url +
        '/GetCSPAddonItems?baseStockCode=' +
        baseStockCode +
        '&subscriptionId=' +
        subscriptionId
      )
      .pipe(catchError(this.authService.handleError));
  }


 


  GetCSPItemListView(tenantId: string): Observable<CSPItemListViewModel> {
    return this.http
      .get<CSPItemListViewModel>(this.base_url + '/GetCSPItemListView?tenantId=' + tenantId)
      .pipe(catchError(this.authService.handleError));
  }

  GetCSPtems(tenantId: string, subscriptionType: string): Observable<AnnuityItemsViewModel[]> {
    return this.http.get<I_AnnuityItemsViewModel[]>(this.base_url + '/GetCSPtems?tenantId=' + tenantId
      + '&subscriptionType=' + subscriptionType
    )
      .pipe(catchError(this.authService.handleError))
      .pipe(map((items) => items.map(item => new AnnuityItemsViewModel(item))));
  }


  getWGSItemsView(tenantId: string): Observable<WGSSubscriptionDetailsItemViewModel> {
    return this.http
      .get<WGSSubscriptionDetailsItemViewModel>(this.base_url + '/GetWGSItemsView?tenantId=' + tenantId)
      .pipe(catchError(this.authService.handleError));
  }

  GetWGSItems(tenantId: string): Observable<I_AnnuityItemsViewModel[]> {
    return this.http.get<I_AnnuityItemsViewModel[]>(this.base_url + '/GetWGSItems?tenantId=' + tenantId)
      .pipe(catchError(this.authService.handleError))
      .pipe(map((items) => items.map(item => new AnnuityItemsViewModel(item))));
  }

  GetKASPtems(subscriptionType: string): Observable<I_AnnuityItemsViewModel[]> {
    return this.http.get<I_AnnuityItemsViewModel[]>(this.base_url + '/GetKASPtems?subscriptionType=' + subscriptionType)
      .pipe(catchError(this.authService.handleError))
      .pipe(map((items) => items.map(item => new AnnuityItemsViewModel(item))));
  }

  GetCirrusItems(subscriptionType: string): Observable<I_AnnuityItemsViewModel[]> {
    return this.http.get<I_AnnuityItemsViewModel[]>(this.base_url + '/GetCirrustems?subscriptionType=' + subscriptionType)
      .pipe(catchError(this.authService.handleError))
      .pipe(map((items) => items.map(item => new AnnuityItemsViewModel(item))));
  }

  GetCSPPartnerCenterUsageView(
    tenantId: string
  ): Observable<CSPUsageDetailsViewModel[]> {
    return this.http
      .get<CSPUsageDetailsViewModel[]>(this.base_url + '/GetCSPPartnerCenterUsageView?tenantId=' + tenantId)
      .pipe(catchError(this.authService.handleError));
  }

  GetCSPPerpetualItemsView(
    tenantId: string
  ): Observable<CSPPerpetualItemViewModel> {
    return this.http
      .get<CSPPerpetualItemViewModel>(this.base_url + '/GetCSPPerpetualItemsView?tenantId=' + tenantId)
      .pipe(catchError(this.authService.handleError));
  }

  GetCSPAzureRIItemsView(
    tenantId: string
  ): Observable<CSPPerpetualItemViewModel> {
    return this.http
      .get<CSPPerpetualItemViewModel>(this.base_url + '/GetCSPAzureRIItemsView?tenantId=' + tenantId)
      .pipe(catchError(this.authService.handleError));
  }

  GetCSPSoftwareSubscriptionItemsView(
    tenantId: string
  ): Observable<CSPPerpetualItemViewModel> {
    return this.http
      .get<CSPPerpetualItemViewModel>(
        this.base_url +
        '/GetCSPSoftwareSubscriptionItemsView?tenantId=' +
        tenantId
      )
      .pipe(catchError(this.authService.handleError));
  }

  GetCSPPerpetualItemList(
    chargeType: string
  ): Observable<CSPPerpetualItemsViewModel[]> {
    return this.http
      .get<CSPPerpetualItemsViewModel[]>(this.base_url + '/GetCSPPerpetualItemList?chargeType=' + chargeType)
      .pipe(catchError(this.authService.handleError));
  }

  CreatePerpetualOrder(model: CSPPerpetualModifyViewModel[]): Observable<PerpetualApiResponse> {
    return this.http
      .post<PerpetualApiResponse>(this.base_url + '/CreatePerpetualOrder', model)
      .pipe(catchError(this.authService.handleError));
  }

  GetCSPAzureRIItemList(
    tenantId: string
  ): Observable<CSPPerpetual_AzureRISubscriptionViewModel> {
    return this.http
      .get<CSPPerpetual_AzureRISubscriptionViewModel>(this.base_url + '/GetCSPAzureRIItemList?tenantId=' + tenantId)
      .pipe(catchError(this.authService.handleError));
  }

  GetAzureSubscriptionTotals(tenantId: string): Observable<any> {
    return this.http
      .get(this.base_url + '/GetAzureSubscriptionTotals?tenantId=' + tenantId)
      .pipe(catchError(this.authService.handleError));
  }

  GetTenantAzureUsageTotals(): Observable<any> {
    return this.http
      .get(this.base_url + '/GetTenantAzureUsageTotals')
      .pipe(catchError(this.authService.handleError));
  }

  GetCspAzureRicatalog(): Observable<CspAzureRicatalog[]> {
    return this.http
      .get<CspAzureRicatalog[]>(this.base_url + '/GetCspAzureRicatalog')
      .pipe(catchError(this.authService.handleError));
  }

  GetCspAzureRiList(
    id: number,
    location: string
  ): Observable<CspAzureRilist[]> {
    return this.http
      .get<CspAzureRilist[]>(
        this.base_url + '/GetCspAzureRiList?id=' + id + '&location=' + location
      )
      .pipe(catchError(this.authService.handleError));
  }

  GetCSPAzureRIList_All(tenantId: string, location: string, reservationType: string): Observable<CspAzureRilist[]> {
    return this.http
      .get<CspAzureRilist[]>(this.base_url + '/GetCSPAzureRIList_All?tenantId=' + tenantId + '&location=' + location + '&reservationType=' + reservationType)
      .pipe(catchError(this.authService.handleError));
  }

  RegisterSubscription(
    tenantId: string,
    subscriptionId: string
  ): Observable<ApiResponse> {
    return this.http
      .get<ApiResponse>(
        this.base_url +
        '/RegisterSubscription?tenantId=' +
        tenantId +
        '&subscriptionId=' +
        subscriptionId
      )
      .pipe(catchError(this.authService.handleError));
  }

  GetProductPricingList(list: string[], showAll?: string): Observable<GetProductPricingV2[]> {
    const extra = showAll ? `?showAll=${showAll}` : ''
    return this.http
      .post<GetProductPricingV2[]>(this.base_url + '/GetProductPricingList' + extra, list)
      .pipe(catchError(this.authService.handleError));
  }

  GetPerpetualDownloadOptions(
    model: CSPPerpetualEntitlementsViewModel
  ): Observable<CSPPerpetualDownloadOptionsViewModel> {
    return this.http
      .post<CSPPerpetualDownloadOptionsViewModel>(this.base_url + '/GetPerpetualDownloadOptions', model)
      .pipe(catchError(this.authService.handleError));
  }

  GetInventoryCheckForAzureRI(
    tenantId: string,
    subscriptionId: string,
    productId: string,
    skuId: string,
    armRegionName: string
  ): Observable<ApiResponse> {
    return this.http
      .get<ApiResponse>(
        this.base_url +
        '/GetInventoryCheckForAzureRI?tenantId=' +
        tenantId +
        '&subscriptionId=' +
        subscriptionId +
        '&productId=' +
        productId +
        '&skuId=' +
        skuId +
        '&armRegionName=' +
        armRegionName
      )
      .pipe(catchError(this.authService.handleError));
  }

  CheckSubscriptionOwnerEmailStatus(
    emailAddress: string,
    tenantId: string
  ): Observable<SubscriptionApiResponse> {
    return this.http
      .get<SubscriptionApiResponse>(
        this.base_url +
        '/CheckSubscriptionOwnerEmailStatus?emailAddress=' +
        emailAddress +
        '&tenantId=' +
        tenantId
      )
      .pipe(catchError(this.authService.handleError));
  }

  GetCSPPartnerCenterUsageSummary(tenantId: string): Observable<ApiResponse> {
    return this.http
      .get<ApiResponse>(
        this.base_url + '/GetCSPPartnerCenterUsageSummary?tenantId=' + tenantId
      )
      .pipe(catchError(this.authService.handleError));
  }

  UpdateTenantInfo(model: any): Observable<ApiResponse> {
    return this.http
      .post<ApiResponse>(this.base_url + '/UpdateTenantInfo', model)
      .pipe(catchError(this.authService.handleError));
  }

  UpdateGenericTenantInfo(model: any): Observable<ApiResponse> {
    return this.http
      .post<ApiResponse>(this.base_url + '/UpdateGenericTenantInfo', model)
      .pipe(catchError(this.authService.handleError));
  }

  GetPartnerProgramDetails(): Observable<PartnerProgramDetail[]> {
    return this.http
      .get<PartnerProgramDetail[]>(this.base_url + '/GetPartnerProgramDetails')
      .pipe(catchError(this.authService.handleError));
  }
  GetADOpportunityByPartnerCSNAndDateRange(
    partnerCSN: string,
    fromDate: string,
    toDate: string
  ): Observable<ADOpportunityByPartnerCSNAndDateRange> {
    return this.http
      .get<ADOpportunityByPartnerCSNAndDateRange>(
        this.base_url +
        '/GetADOpportunityByPartnerCSNAndDateRange?partnerCSN=' +
        partnerCSN +
        '&fromDate=' +
        fromDate +
        '&toDate=' +
        toDate
      )
      .pipe(catchError(this.authService.handleError));
  }
  GetADOpportunityByPartnerCSNAndOpportunityID(
    partnerCSN: string,
    opportunityID: string
  ): Observable<ADOpportunityByPartnerCSNAndDateRange> {
    return this.http
      .get<ADOpportunityByPartnerCSNAndDateRange>(
        this.base_url +
        '/GetADOpportunityByPartnerCSNAndOpportunityID?partnerCSN=' +
        partnerCSN +
        '&opportunityID=' +
        opportunityID
      )
      .pipe(catchError(this.authService.handleError));
  }
  GetTransactOpportunity(
    model: TransactOpportunityInput
  ): Observable<TransactOpportunityModel> {
    return this.http
      .post<TransactOpportunityModel>(this.base_url + '/GetTransactOpportunity', model)
      .pipe(catchError(this.authService.handleError));
  }
  GetPartnerByMPNId(mpnId: string): Observable<MnpIdAipiResponse> {
    return this.http
      .get<MnpIdAipiResponse>(this.base_url + '/GetPartnerByMPNId?mpnId=' + mpnId)
      .pipe(catchError(this.authService.handleError));
  }
  // GetSupportedBillingCycleType(stockCode:any): Observable<any> {
  //   return this.http
  //   .get(this.base_url + '/GetSupportedBillingCycleType?stockCode=' + stockCode)
  //   .pipe(catchError(err => {
  //     this.authService.handleError;
  //     throw err;
  //   }));  

  // }


  GetSupportedBillingCycleType(tenantId: string, skuList: string[]): Observable<SupportedBillingCycle[]> {
    return this.http
      .get<SupportedBillingCycle[]>(this.base_url + '/GetSupportedBillingCycleType?tenantId=' + tenantId + '&skuList=' + skuList)
      .pipe(catchError(this.authService.handleError));

  }
  GetMPAStatusByMPNId(mpnId: string): Observable<MnpIdAipiResponse> {
    return this.http
      .get<MnpIdAipiResponse>(this.base_url + '/GetMPAStatusByMPNId?mpnId=' + mpnId)
      .pipe(catchError(this.authService.handleError));
  }

  IsAzureUpgradeInProgress(tenantId: string): Observable<any> {
    return this.http
      .get(this.base_url + '/IsAzureUpgradeInProgress?tenantId=' + tenantId)
      .pipe(catchError(this.authService.handleError));
  }

  InitiateAzureUpgrade(tenantId: string): Observable<any> {
    return this.http
      .get(this.base_url + '/InitiateAzureUpgrade?tenantId=' + tenantId)
      .pipe(catchError(this.authService.handleError));
  }

  CheckAzureUpgradeEligibility(tenantId: string): Observable<any> {
    return this.http
      .get(this.base_url + '/CheckAzureUpgradeEligibility?tenantId=' + tenantId)
      .pipe(catchError(this.authService.handleError));
  }

  // GetItemType
  GetCSPCustomerEntitlmentsView(tenantId: string): Observable<CSPCustomerEntitlementsViewModel[]> {
    return this.http
      .get<CSPCustomerEntitlementsViewModel[]>(
        this.base_url + '/GetCSPCustomerEntitlementView?tenantId=' + tenantId
      )
      .pipe(catchError(this.authService.handleError));
  }

  GetCSPSoftwareSubscriptionsView(tenantId: string): Observable<CSPCustomerEntitlementsViewModel[]> {
    return this.http
      .get<CSPCustomerEntitlementsViewModel[]>(
        this.base_url + '/GetCSPSoftwareSubscriptionsView?tenantId=' + tenantId
      )
      .pipe(catchError(this.authService.handleError));
  }

  CheckSoftwareAndRISubscription(tenantId: string, stockCode: string, orderId: string): Observable<any> {
    return this.http
      .get(this.base_url + `/GetSubscriptionByOrderId/${tenantId}/${stockCode}/${orderId}`)
      .pipe(catchError(this.authService.handleError));
  }
  // GetCSPSoftwareItem
  GetCSPSoftwareItemList(): Observable<CSPPerpetualItemsViewModel[]> {
    return this.http
      .get<CSPPerpetualItemsViewModel[]>(this.base_url + '/GetCSPSoftwareItemList')
      .pipe(catchError(this.authService.handleError));
  }

  UpdateAnnuityDigitalWallet(customerPaymentNumber: string, annuityId: string): Observable<ApiResponse> {
    return this.http
      .get<ApiResponse>(this.base_url + '/UpdateAnnuityDigitalWallet?customerPaymentNumber=' + customerPaymentNumber + '&annuityId=' + annuityId)
      .pipe(catchError(this.authService.handleError));
  }

  GetRenewalStatuses(): Observable<any> {
    return this.http
      .get(this.base_url + '/GetRenewalStatuses')
      .pipe(catchError(this.authService.handleError));
  }

  // UpdateXRenewalHeader(serial: string, status: string, comments: string): Observable<any> {
  //   return this.http
  //     .get(this.base_url + '/UpdateXRenewalHeader?serial=' + serial + '&status=' + status + '&comments=' + comments)
  //     .pipe(catchError(this.authService.handleError));
  // }

  UpdateXRenewalHeader(serial: string, status: string, comments: string): Observable<any> {
    return this.http.
      post(this.base_url + '/UpdateXRenewalHeader', {
        serial: serial,
        status: status,
        comments: comments
      })
      .pipe(catchError(this.authService.handleError));
  }

  // Configure Portal Management
  getTenantUsers(tenantId: string): Observable<CSPTenantUser[]> {
    return this.http.get<CSPTenantUser[]>(this.base_url + '/GetTenantUsers/' + tenantId)
      .pipe(catchError(this.authService.handleError));
  }

  removeTenantUser(Id: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.base_url + '/RemoveTenantUser/' + Id)
      .pipe(catchError(this.authService.handleError));
  }

  CreateTenantUsers(tenantId: string, users: CSPTenantUser[]): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.base_url + '/CreateTenantUsers/' + tenantId, users)
      .pipe(catchError(this.authService.handleError));
  }

  updateTenantBranding(formData: FormData): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.base_url + '/UpdateTenantBranding/', formData)
      .pipe(catchError(this.authService.handleError));
  }
  updateTenantBranding_V1(formData: FormData): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.base_url + '/UpdateTenantBranding_V1/', formData)
      .pipe(catchError(this.authService.handleError));
  }

  getTenantBranding(tenantId: string): Observable<any> {
    return this.http.get(this.base_url + '/GetTenantBranding/' + tenantId)
      .pipe(catchError(this.authService.handleError));
  }

  getTenantBranding_V1(tenantId: string): Observable<any> {
    return this.http.get(this.base_url + '/GetTenantBranding_V1/' + tenantId)
      .pipe(catchError(this.authService.handleError));
  }

  deleteTenantLogo(tenantId: string): Observable<any> {
    return this.http.get(this.base_url + '/DeleteTenantLogo/' + tenantId)
      .pipe(catchError(this.authService.handleError));
  }

  searchTenantUsers(tenantId: string, searchString: string): Observable<any> {
    return this.http.get(this.base_url + '/SearchTenantUsers/' + tenantId + '?searchString=' + searchString)
      .pipe(catchError(this.authService.handleError));
  }

  GetCSPAzureRIList_All_Duration(list: number[]): Observable<any[]> {
    return this.http
      .post<number[]>(this.base_url + '/GetCSPAzureRIList_All_Duration', list)
      .pipe(catchError(this.authService.handleError));
  }

  GetMonthlyBillingEligibleCSPStockcodes(): Observable<string[]> {
    return this.http.get<string[]>(this.base_url + '/GetMonthlyBilling_Eligible_CSPStockcodes')
      .pipe(catchError(this.authService.handleError));
  }

  getReservationtypes(): any {
    return this.http.get(this.base_url + '/GetReservationtypes')
      .pipe(catchError(this.authService.handleError));
  }

  GetTransitionEligibilities(tenantId: string, subscriptionId: string, isScheduled: boolean = false): Observable<TransitionEligibility[]> {
    return this.http.get<TransitionEligibility[]>(
        this.base_url +
        '/GetTransitionEligibilities?tenantId=' +
        tenantId +
        '&subscriptionId=' +
        subscriptionId +
        '&isScheduled=' +
        isScheduled
      )
      .pipe(catchError(this.authService.handleError));
  }

  PostTransition(tenantId: string, subscriptionId: string, stockCode: string, offerId: string, renewalDate: string, transition: Transition) {
    return this.http.post(`${this.base_url}/PostTransition/${tenantId}/${subscriptionId}/${stockCode}/${offerId}/${renewalDate}`, transition)
      .pipe(catchError(this.authService.handleError));
  }

  CancelSubscription(tenantId: string, subscriptionId: string, stockCode: string, offerId: string, renewalDate: string) {
    return this.http.post(`${this.base_url}/CancelSubscription`, {
      tenantId,
      subscriptionId,
      stockCode,
      offerId,
      renewalDate
    }).pipe(catchError(this.authService.handleError));
  }

  GetSubscription(tenantId: string, subscriptionId: string) {
    return this.http.get(`${this.base_url}/GetSubscription/${tenantId}/${subscriptionId}`)
  }

  UpdateSubscriptionCycle(tenantId: string, subscriptionId: string, stockCode: string, offerId: string, qty: number, action: string, renewalDate: string, productTerm: ProductTerm, customTermEndDate: String = null) {
    return this.http.post(`${this.base_url}/UpdateSubscriptionCycle/${tenantId}/${subscriptionId}/${stockCode}/${offerId}/${qty}/${action}/${renewalDate}` + (customTermEndDate ? `/${customTermEndDate}` : '/null'), productTerm)
      .pipe(catchError(this.authService.handleError));
  }

  UpdateNCERenewalQty(tenantId: string, subscriptionId: string, stockCode: string, offerId: string, qty: number, action: string, renewalDate: string) {
    return this.http.get(`${this.base_url}/UpdateNCERenewalQty/${tenantId}/${subscriptionId}/${stockCode}/${offerId}/${qty}/${action}/${renewalDate}`)
      .pipe(catchError(this.authService.handleError));
  }

  UpdateSubscriptionRenew(tenantId: string, subscriptionId: string, stockCode: string, autoRenew: boolean, renewalDate: string) {
    return this.http.post(`${this.base_url}/UpdateSubscriptionRenew`, {
      tenantId,
      subscriptionId,
      stockCode,
      autoRenew,
      renewalDate
    }).pipe(catchError(this.authService.handleError));
  }

  GetSkubyId(productId: string, skuId: string) {
    return this.http.get(`${this.base_url}/GetSkubyId/${productId}/${skuId}`)
  }

  GetOfferbyId(offerId: string) {
    return this.http.get(`${this.base_url}/GetOfferbyId/${offerId}`)
  }

  GetNCERenewStatus(tenantId: string, subscriptionId: string) {
    return this.http.get(`${this.base_url}/GetNCERenewStatus/${tenantId}/${subscriptionId}`)
  }

  GetWGSSubscriptionDetail(tenantId: string, subscriptionId: string): Observable<WGSSubscriptionDetail> {
    return this.http.get<WGSSubscriptionDetail>(`${this.base_url}/GetWGSSubscriptionDetail/${tenantId}/${subscriptionId}`)
  }

  MigrationToNCE(cspMigrationToNCE: CSPMigrationToNCE): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.base_url + '/MigrationToNCE', cspMigrationToNCE)
      .pipe(catchError(this.authService.handleError));
  }

  /**
   * Autodesk subscription duration term change
   * 
   * @param term Subscription duration term (3 yeays/annual)
   * @param serials the list of autodesk subscriptions serial number
   * @returns Status and message
   */
  public AutodeskTermSwitch(term: string, serials: string[]): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.base_url + '/AutodeskTermSwitch', { term, serials })
      .pipe(catchError(this.authService.handleError));
  }

  /**
   * Get Azure RI purchase right status
   * 
   * @param tenantId
   * @returns string status of the purchase right
   */
  public getAzureRIPurchaseRights(tenantId: string): Observable<string> {
    return this.http.get<string>(this.base_url + '/GetAzureRIPurchaseRights/?tenantId=' + tenantId)
      .pipe(catchError(this.authService.handleError));
  }

  /**
   * Get Azure cost management status
   * 
   * @param tenantId
   * @returns string status of the cost management
   */
  public GetAzureCostManagementPolicy(tenantId: string): Observable<string> {
    return this.http.get<string>(this.base_url + '/GetAzureCostManagementPolicy/?tenantId=' + tenantId)
      .pipe(catchError(this.authService.handleError));
  }
  /**
     * Get Azure savings plan
     * 
     * @param tenantId
     * @returns string status of the purchase right
     */
  public getAzureSavingsPlan(tenantId: string): Observable<string> {
    return this.http.get<string>(this.base_url + '/GetAzureSavingsPlan/?tenantId=' + tenantId)
      .pipe(catchError(this.authService.handleError));
  }
  /**
   * Change Azure RI purchase right status
   * 
   * @param tenantId
   * @param permission status changing to
   * @returns
   */  
  public ManageAzureRIPermission(tenantId: string, permission: string): Observable<ApiResponse> {
    const formData: FormData = new FormData();
    formData.append('tenantId', tenantId);
    formData.append('permission', permission);
    return this.http.post<ApiResponse>(this.base_url +
      '/ManageAzureRIPermission/?tenantId=' +
      tenantId +
      '&permission=' +
      permission,
      formData
    )
      .pipe(catchError(this.authService.handleError));
  }

  /**
   * Change Azure Cost Management right status
   * 
   * @param tenantId
   * @param permission status changing to
   * @returns
   */
  public SetAzureCostsPolicy(tenantId: string, permission: string): Observable<string> {
    const formData: FormData = new FormData();
    formData.append('tenantId', tenantId);
    formData.append('permission', permission);
    return this.http.post<string>(this.base_url +
      '/SetAzureCostsPolicy/?tenantId=' +
      tenantId +
      '&permission=' +
      permission,
      formData
    )
      .pipe(catchError(this.authService.handleError));
  }
  /**
    * Change Azure savings plan
    * 
    * @param tenantId
    * @param permission status changing to
    * @returns
    */
  public ManageAzureSavingsPlan(tenantId: string, permission: string): Observable<string> {
    const formData: FormData = new FormData();
    formData.append('tenantId', tenantId);
    formData.append('permission', permission);
    return this.http.post<string>(this.base_url +
      '/ManageAzureSavingsPlan/?tenantId=' +
      tenantId +
      '&permission=' +
      permission,
      formData
    )
      .pipe(catchError(this.authService.handleError));
  }
  public GetAvailableAdminRelationshipTitles(): Observable<string[]> {
    return this.http
      .get<string[]>(this.base_url + '/GetAvailableAdminRelationshipTitles')
      .pipe(catchError(this.authService.handleError));
  }

  /**
   * List all current existing admin relationships
   */
  public GetCustomerAdminRelationShip(tenantId: string): Observable<any> {
    return this.http.get(this.base_url + '/GetCustomerAdminRelationShip/?tenantId=' + tenantId)
      .pipe(catchError(err => {
        this.authService.handleError;
        throw err
      }));
  }

  public createAdminRelationship(tenantId: string, days: number, roleId: string): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.base_url + '/Create_CustomerAdminRelationShip', { tenantId, days, roleId })
      .pipe(catchError(this.authService.handleError));
  }

  public terminateAdminRelationship(relationId: string): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(this.base_url + '/Delete_CustomerAdminRelationShip?relation_id=' + relationId)
      .pipe(catchError(this.authService.handleError));
  }

  public GetAzureEntitlements(tenantId: string, azurePlanId: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.base_url + '/GetAzureEntitlements/?tenantId=' + tenantId + '&azurePlanId=' + azurePlanId)
      .pipe(catchError(this.authService.handleError));
  }

  public GetBudgetAlertList(tenantId: string, subscriptionId: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.base_url + '/GetBudgetAlertList/?tenantId=' + tenantId + '&subscriptionId=' + subscriptionId)
      .pipe(catchError(this.authService.handleError));
  }

  public GetBudgetAlertByName(tenantId: string, budgetName: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.base_url + '/GetBudgetAlertByName/?tenantId=' + tenantId + '&budgetName=' + budgetName)
      .pipe(catchError(this.authService.handleError));
  }

  public updateBudget(tenantId: string, budgetName: string, amount: number, subscriptionId: string, notifications: Notifications): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.base_url + '/Update_BudgetAlert/?tenantId=' + tenantId + '&budgetName=' + budgetName + '&amount=' + amount + '&subscriptionId=' + subscriptionId, notifications)
      .pipe(catchError(this.authService.handleError));
  }

  public createBudget(tenantId: string, budgetName: string, subscriptionId: string, request: Request): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.base_url + '/Create_BudgetAlert/?tenantId=' + tenantId + '&budgetName=' + budgetName + '&subscriptionId=' + subscriptionId, request)
      .pipe(catchError(this.authService.handleError));
  }

  public getCSPFraudAlertList(subscriptionId: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.base_url + '/GetCSP_FraudAlertList/?subscriptionId=' + subscriptionId)
      .pipe(catchError(this.authService.handleError));
  }

  public getCSPFraudAlertList_ByTenant(tenantId: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.base_url + '/GetCSP_FraudAlertListBy_Tenant/?tenantId=' + tenantId)
      .pipe(catchError(this.authService.handleError));
  }


  public updateFraudAlertStatus(subscriptionId: String, EventIds: string[], EventStatus: string, ResolvedReason: string): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.base_url + '/Update_Fraud_AlertStatus/?subscriptionId=' + subscriptionId, { EventIds, EventStatus, ResolvedReason })
      .pipe(catchError(this.authService.handleError));
  }

  public deleteBudget(tenantId: string, budgetName: string): Observable<ApiResponse> {
    const formData: FormData = new FormData();
    formData.append('tenantId', tenantId);
    formData.append('budgetName', budgetName);
    return this.http.post<ApiResponse>(this.base_url + '/Delete_BudgetAlert/?tenantId=' + tenantId + '&budgetName=' + budgetName, formData)
      .pipe(catchError(this.authService.handleError));
  }

  public createAzureSubscriptionForAzurePlan(tenantId: string, subscriptionId: string, displayName: string): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.base_url +
      '/Create_AzureSubscriptionForAzurePlan',
      {
        tenantId,
        subscriptionId,
        displayName
      })
      .pipe(catchError(this.authService.handleError));
  }

  /**
   *  Create quote for selected renewal opportunity
   *  If quote already exists, refresh quote under same quote number 
   *  
   */
  public createAutodeskQuote(adOpportunityDetail: string, accountCode: string, contactName: string, contactEmail: string, quoteId: string): Observable<any> {
    const formData: FormData = new FormData();
    // current quote Id
    formData.append('quoteId', quoteId);
    // opportunity data
    formData.append('adData', adOpportunityDetail);
    // account code
    formData.append('accountCode', accountCode);
    // contact name
    formData.append('contactName', contactName);
    // contact email
    formData.append('contactEmail', contactEmail);

    return this.http.post(this.base_url + '/CreateADQuote/', formData, {
      headers:
      {
        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
        'Access-Control-Allow-Headers': 'X-QuoteId, X-QuoteVersion'
      },
      responseType: 'blob',
      observe: 'response'
    })
      .pipe(catchError(this.authService.handleError));

  }

  public downloadQuote(quoteId: string, quoteVersion: string): Observable<any> {
    const formData: FormData = new FormData();
    // current quote Id
    formData.append('quoteId', quoteId);
    // current quote version
    formData.append('quoteVersion', quoteVersion);


    return this.http.post(this.base_url + '/DownloadQuote?quoteId=' + quoteId + "&quoteVersion=" + quoteVersion, formData, { headers: { 'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' }, responseType: 'blob' })
      .pipe(catchError(this.authService.handleError));
  }

  public checkForQuote(opportunityNumber, accountId): Observable<any> {

    return this.http.get<any>(this.base_url + '/CheckForADRenewalQuote?opportunityNumber=' + opportunityNumber + '&accountId=' + accountId)
      .pipe(catchError(this.authService.handleError));
  }

  public AssignTenantUser(tenantId: string, userEmail: string): Observable<any> {
    return this.http.post(this.base_url + '/AssignTenantUser/' + tenantId, JSON.stringify(userEmail), {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    }
    )
      .pipe(catchError(this.authService.handleError));
  }

  public ReAssignTenantUser(tenantId: string, userEmail: string): Observable<any> {
    return this.http.post(this.base_url + '/ReAssignTenantUser/' + tenantId, JSON.stringify(userEmail), {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    }
    )
      .pipe(catchError(this.authService.handleError));
  }

  public ReturnESDToken(token: string): Observable<any> {
    return this.http.post(this.base_url + '/ReturnESDToken', JSON.stringify(token), {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    }
    )
      .pipe(catchError(this.authService.handleError));
  }

  public toggleWGSStaus(status: string, subId: string, tenantId: string): Observable<any> {
    return this.http.post(this.base_url + '/ToggleWGSStaus?tenantId=' + tenantId + '&subscriptionId=' + subId, JSON.stringify(status), {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    }
    )
      .pipe(catchError(this.authService.handleError));
  }

  public cancelWGSContract(subId: string, tenantId: string): Observable<any> {
    return this.http.put(this.base_url + '/CancelWGSContract?tenantId=' + tenantId + '&subscriptionId=' + subId,
      {
        headers: new HttpHeaders().set('Content-Type', 'application/json')
      }
    )
      .pipe(catchError(this.authService.handleError));
  }

  public addWGSSerial(serial: string, subId: string, tenantId: string): Observable<any> {
    return this.http.post(this.base_url + '/AddWGSSerial?tenantId=' + tenantId + '&subscriptionId=' + subId, JSON.stringify(serial), {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    }
    )
      .pipe(catchError(this.authService.handleError));
  }
  

  public createWGSTenant(formCollection: string): Observable<TenantResponse> {
    return this.http.get<TenantResponse>(`${this.base_url}/CreateWGSTenant?formCollection=${formCollection}`)
      .pipe(catchError(this.authService.handleError));
  }

  public validateBulkDomains(file: any): Observable<any> {
    return this.http.post<any>(this.base_url + '/validateBulkDomains', file)
  }

  public validateBulkTransfer(file: any): Observable<any> {
    return this.http.post<any>(this.base_url + '/ValidateBulkTransfer', file)
  }

  public associateValidDomains(data: AssociateValidationResult[]): Observable<any> {
    return this.http.post<any>(this.base_url + '/BulkAssociateCSPTenant', data)
      .pipe(catchError(this.authService.handleError));
  }
  public BulkCSPTransferActions(data: BulkOrderValidationResult[]): Observable<any> {
    return this.http.post<any>(this.base_url + '/BulkCSPTransferActions', data)
      .pipe(catchError(this.authService.handleError));
  }

  public importBulkOrder(file: any): Observable<any> {
    return this.http.post<any>(this.base_url + '/BulkCSPExcelImport', file)
  }
  
  
  public actionCreateRemoveRetry(lineIds: number[],action: string): Observable<ApiResponse> {  
    return this.http.post<ApiResponse>(this.base_url + '/BulkCSPOrderActions/?actions=' + action , lineIds)
      .pipe(catchError(this.authService.handleError));      
  } 

  public previewCustomPricing(file: any): Observable<any> {
    return this.http.post<any>(this.base_url + '/previewCustomPricing', file)
  }

  public DownloadCustomPricing(customerId: string):  Observable<any> {
    return this.http
      .get(this.base_url + '/DownloadCustomPricing?customerId=' + customerId, {
        responseType: 'blob',
        headers: {
          Accept:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
        },
      })
      .pipe(catchError(this.authService.handleError));     
  }

  public GetBulkOrderData(pageView: string): Observable<any> {   
    return this.http.get(this.base_url + '/GetBulkOrderData?pageView=' + pageView , {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    }
    )
      .pipe(catchError(this.authService.handleError));
    }

  public getAMPOrdersByCustomer(tenantId: string): Observable<IAMPAssociationResponse[]> {
    return this.http.get<IAMPAssociationResponse[]>(this.controller + '/GetCSPOrdersByCustomer?tenantId=' + tenantId)
      .pipe(catchError(this.authService.handleError));
  }

  public backToTenentPage(tenantId: string): void {
    if (this.router.url.includes('customers')) {
      this.customerService.currentCustomerWatch.pipe(first()).subscribe((res: DDCustomer) => { 
          this.router.navigateByUrl("/customers/" + res?.id  + "/CSP/" + tenantId);
      });
    } else {
      this.router.navigateByUrl("/manageSubscriptions/manageAnnuities/CSP/CSPDetailsNew/" + tenantId);
    }
  }

  public downloadExcelSubConfirmProducts(model: CSPModifySubscriptionViewModel[]): Observable<any> {
    return this.http
      .post(this.controller + '/downloadExcelSubConfirmProducts', model,{
        responseType: 'blob',
        headers: {
          Accept:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
        },
      })
      .pipe(catchError(this.authService.handleError)); 
  }
  public downloadExcelSoftwareConfirmProducts(model: CSPPerpetualModifyViewModel[]): Observable<any> {
    return this.http
      .post(this.controller + '/downloadExcelSoftwareConfirmProducts', model,{
        responseType: 'blob',
        headers: {
          Accept:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
        },
      })
      .pipe(catchError(this.authService.handleError)); 
  }
}
